import { UserTypes } from 'config/global-enums';

export const defaultAuthHome = {
  [UserTypes.EMPLOYEE]: '/home-in',
  [UserTypes.CUSTOMER]: '/customer-home-in',
  [UserTypes.PARTNER]: '/partner-home-in',
};
